import React, { FC } from "react";
import { useTranslation } from 'react-i18next';
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import styles from "./ConfirmDeleteModal.module.scss";

interface IConfirmDeleteModal {
  visible: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  activitieIdentifier: string;
}

const ConfirmDeleteModal: FC<IConfirmDeleteModal> = ({
  visible,
  loading,
  onCancel,
  onConfirm,
  activitieIdentifier,
}) => {
  const { t } = useTranslation('activities');
  const footerConfirmButtons = (
    <div className={styles['buttons']}>
      <Button
        onClick={onCancel}
        type="text"
        className={styles['buttonCancel']}
      >
        {t('deleteModal.cancel')}
      </Button>
      <Button
        id="deleteBtn"
        type="primary"
        htmlType="submit"
        onClick={onConfirm}
        className={styles['buttonSubmit']}
        loading={loading}
        danger
      >
        {t('deleteModal.delete')}
      </Button>
    </div>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footerButtons={footerConfirmButtons}
      footerActive={false}
      width={400}
      customClassName
    >
      <div className={styles['wrapper']}>
        <span className={styles['title']}>
          {t('deleteModal.title')}
        </span>
        <hr className={styles['midleHr']} />
        <span className={styles['description']}>
          {t('deleteModal.descriptionText', { identifier: activitieIdentifier })}
        </span>
        <span className={styles['description']}>
          {t('deleteModal.permanentText')}
        </span>
      </div>
      <hr className={styles['footerHr']} />
    </Modal>
  )
}

export default ConfirmDeleteModal;
